<template>
  <DropdownTarget v-slot="{ show, visible, hide }" @hide="$emit('close')">
    <div
      @click="show"
      class="hot-point-hint__dot"
      :class="bem('hot-point-hint__dot', { withBorder })"
    />
    <TransitionFade>
      <BasicDropdown
        v-if="visible"
        class="hot-point-hint__dropdown"
        :width="306"
      >
        <div class="hot-point-hint__popper">
          <button type="button" class="hot-point-hint__button" @click="hide">
            <SvgIcon
              icon="cross"
              size="12"
              color="light-blue"
              class="hot-point-hint__close"
            />
          </button>
          <h5 class="hot-point-hint__title">
            <slot name="title" />
          </h5>
          <slot />
        </div>
      </BasicDropdown>
    </TransitionFade>
  </DropdownTarget>
</template>

<script>
import { bem } from 'src/utils/bem.js';

import BasicDropdown from 'src/components/BasicDropdown/BasicDropdown.vue';
import DropdownTarget from 'src/components/DropdownTarget/DropdownTarget.vue';
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
import TransitionFade from 'src/components/transitions/TransitionFade/TransitionFade.vue';

export default {
  name: 'HotPointHint',
  components: { DropdownTarget, BasicDropdown, TransitionFade, SvgIcon },
  props: {
    withBorder: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  methods: { bem },
};
</script>
